import { InvoiceEventType } from '../../enums/invoiceEventType'
import type { InvoiceEvent } from '../../types/invoices/invoiceEvent'

export const isEInvoiceSentEvent = (event: InvoiceEvent): boolean =>
  event.eventType === InvoiceEventType.DeliveryInhouseEinvoiceSent
